import axios from "axios";
import Cookies from "js-cookie";
import { refreshAccessToken } from "./authService";
import { handleAxiosError } from "./errorHandler";
import {
  triggerSessionExpired,
  triggerNetworkError,
} from "../context/SessionContext";
import { apiPath } from "../constants/defaultValues";

const api = axios.create({
  baseURL: apiPath,
  headers: { "Content-Type": "application/json" },
});


api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("access_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (!error.response) {
      console.warn("Network error detected:", error.message);
      triggerNetworkError();
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !original._retry) {
      original._retry = true;

      try {
        const newToken = await refreshAccessToken();
        if (!newToken) {
          triggerSessionExpired();
          return Promise.reject(error);
        }

        Cookies.set("access_token", newToken);
        original.headers.Authorization = `Bearer ${newToken}`;

        return api(original);
      } catch (e) {
        console.error("OST token refresh FAILED", e);
        triggerSessionExpired();
        return Promise.reject(e);
      }
    }
    if (
      error.response.status === 401 &&
      error.response.data?.error === "invalid_token"
    ) {
      triggerSessionExpired();
    }

    handleAxiosError(error);

    return Promise.reject(error);
  }
);

export default api;


// import axios from 'axios';
// import Cookies from 'js-cookie';
// import { refreshAccessToken } from './authService';
// import { handleAxiosError } from './errorHandler';
// import { apiPath } from '../constants/defaultValues';
// import { triggerSessionExpired, triggerNetworkError } from '../context/SessionContext';


// const apiInstance = axios.create({
//   baseURL: apiPath,
//   headers: { 'Content-Type': 'application/json' },
// });

// apiInstance.interceptors.request.use(
//   (config) => {
//     const token = Cookies.get('access_token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

// apiInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     // ✅ Handle 401 errors (token expired)
//     if (error.response?.status === 401 && !error.config._retry) {
//       error.config._retry = true;
//       try {
//         const newToken = await refreshAccessToken();
//         if (newToken) {
//           Cookies.set('access_token', newToken);
//           error.config.headers.Authorization = `Bearer ${newToken}`;
//           return apiInstance(error.config);
//         } else {
//           // triggerSessionExpired(); // open session expired
//         }
//       } catch (refreshError) {
//         console.error('Token refresh failed:', refreshError);
//         // triggerSessionExpired(); // open session expired
//       }
//     }

//     // handle network errors like dns issues or server down
//     if (!error.response) {
//       console.error('Network error detected:', error.message);
//       // triggerNetworkError(); // open network error modal
//     }

//     // show toast message for any error 
//     handleAxiosError(error);

//     return Promise.reject(error);
//   },
// );

// export default apiInstance;